import { simpleFetch } from './customFetch';

export const getNextBox = () =>
  simpleFetch('/customize/self/seasons/current', {}, process.env.REACT_APP_CUSTOMIZE_API);
